import { render } from "./Conclusion.vue?vue&type=template&id=2940ea58&scoped=true"
import script from "./Conclusion.vue?vue&type=script&lang=js"
export * from "./Conclusion.vue?vue&type=script&lang=js"

import "./Conclusion.vue?vue&type=style&index=0&id=2940ea58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2940ea58"

export default script